import { Actions } from "@client/actions";
import { type AppState } from "@client/types";
import { type ReduxAction } from "@client/types/ReduxAction";
import { closeMenu } from "@client/widgets/Header/actions";
import { type Dispatch, type MiddlewareAPI } from "redux";

export default (api: MiddlewareAPI<Dispatch<any>, AppState>) => (next) => (action: ReduxAction<any>) => {
  switch (action.type) {
    case Actions.LoadPageSuccess: {
      api.dispatch(closeMenu());

      break;
    }
  }

  next(action);
};
